/**
 * Resolve the API base URL with no Firebase or browser side effects at import time.
 * Kept separate from api.ts so static marketing pages can import this helper without
 * dragging in the Firebase SDK.
 */
export function getApiBaseUrl(): string {
  if (import.meta.env.VITE_API_URL) {
    return import.meta.env.VITE_API_URL;
  }

  if (typeof window === 'undefined') {
    return '';
  }

  const host = window.location.hostname;

  // Managed stacks — the stack serves SPA and API on one origin
  // (<id>.stacks.valuepath.io), so the API is same-origin relative /api.
  if (host.endsWith('.stacks.valuepath.io')) {
    return '';
  }

  // Prod — app lives on app.valuepath.io; the bare / www domains serve the
  // marketing site (which doesn't call the API), but include them as a safety
  // net in case this ever runs there.
  if (host === 'app.valuepath.io' || host === 'valuepath.io' || host === 'www.valuepath.io') {
    return 'https://api.valuepath.io';
  }

  return '';
}
